<app-colored-background [backgroundColor]="'#B84730'">
  <app-header [progress]="1" [title]="locale.currentTranslation.informationHeader" [showProgressIndicator]="false"
              [useWhiteFontColor]="true"></app-header>
  <div>
    <div class="base-content-container">
      <div>
        <div class="headline1" style="color: #FFFFFF">
          {{ locale.currentTranslation.important}}
        </div>
        <div class="text-body1" style="color: #FFFFFF; margin-top: 8px;">
          <div>
            {{locale.currentTranslation.dutyInformation3}}
          </div>
          <div style="margin-top: 21px;">
            {{locale.currentTranslation.dutyInformation4}}
          </div>
        </div>
      </div>
    </div>
    <app-finish-box></app-finish-box>
    <div class="main-button-spacing">
      <button class="main-button" data-testid="btn-start-claim-report" routerLink="/user-participation">{{ locale.currentTranslation.nextClaimReport }}</button>
    </div>
  </div>

  <app-footer></app-footer>
</app-colored-background>
